var _clipPath, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegendBuilderChoicei = function SvgLegendBuilderChoicei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99418 0 0 1.00049 -.447 -.348)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "legend-builder-choice_i_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.45.348h32.187v31.984H.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#legend-builder-choice_i_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M32.638 2.347A2.006 2.006 0 0 0 30.626.35H2.461C1.351.35.45 1.245.45 2.347v27.987c0 1.103.902 1.999 2.011 1.999h28.165c1.11 0 2.012-.896 2.012-2V2.348z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.682 17.014a.531.531 0 0 1 .012 1.016l-3.603 1.145a1 1 0 0 0-.65.65l-1.16 3.696a.47.47 0 0 1-.898-.007l-2.476-8.327a.465.465 0 0 1 .581-.578l8.194 2.405zm-11.663.312-1.55 1.54c-.196.195-.196.511 0 .707s.515.195.711 0l1.55-1.54c.196-.195.196-.512 0-.707s-.515-.195-.711 0zM9.033 15.42h2.23c.278 0 .504-.224.504-.5s-.226-.5-.503-.5H9.033c-.278 0-.503.224-.503.5s.225.5.503.5zm10.088-5.151-1.55 1.539c-.196.195-.196.512 0 .706s.515.196.711 0l1.55-1.539c.197-.196.197-.512 0-.706s-.515-.196-.71 0zm-8.652.706 1.55 1.54c.196.195.515.195.711 0s.196-.512 0-.707l-1.55-1.54c-.196-.195-.515-.195-.711 0s-.196.511 0 .707zm5.184.035V8.841c0-.276-.225-.5-.503-.5s-.503.224-.503.5v2.17a.502.502 0 0 0 1.006 0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegendBuilderChoicei);
export default ForwardRef;